export const VIEW_CONFIG = '__view_config';
export function getViewConfig(facade) {
    return facade[VIEW_CONFIG];
}

//# sourceMappingURL=ViewConfig.js.map